import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'hooks';
import { ENTITY } from 'modules/campaigns/config';
import { REPORT_ENTITY_IDS } from 'modules/campaigns/hooks/useReportEntityIds';
import { REPORT_ENTITY_TYPE } from 'modules/campaigns/hooks/useReportEntityType';
import { REPORT_ID } from 'modules/campaigns/modules/campaigns-reports/hooks/useSelectedReportId';
import { useMultiLayerDrawerEnabled } from '../../../../multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { mergeQueryParams } from '../../../../taboola-common-frontend-modules/query-params';

export const useNavigateToSelectedCampaign = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();

    return useCallback(
        (selectedCampaign, reportId) => {
            const { id, campaignId } = selectedCampaign;
            if (isMultiLayerDrawerEnabled) {
                navigate(`${location.pathname}`, {
                    [REPORT_ENTITY_IDS]: campaignId || id,
                    [REPORT_ENTITY_TYPE]: ENTITY.CAMPAIGN,
                    [REPORT_ID]: reportId,
                });
                return;
            }

            navigate(
                `${location.pathname}${mergeQueryParams({
                    [REPORT_ENTITY_IDS]: campaignId || id,
                    [REPORT_ENTITY_TYPE]: ENTITY.CAMPAIGN,
                    [REPORT_ID]: reportId,
                })}`
            );
        },
        [navigate, location, isMultiLayerDrawerEnabled]
    );
};
